<div class="row">
    <div>
        <app-filter-history
            (filter)="filter($event)"
            [listApplicants$]="listApplicants$"
        >
        </app-filter-history>

        <hr />

        <app-table-history
            [listHistory$]="listHistory$"
            [historySelected]="historySelected$ | async"
            [pagination$]="pagination$"
            [idModel]="idModel"
            [typeModel]="typeModel"
        >
        </app-table-history>

        <app-pargination
            [pargination]="pagination$ | async"
            (pageChange)="onPageChange($event)"
        ></app-pargination>
    </div>
</div>
